import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { Pressable } from "@/components/ui/pressable";
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { FlatList } from "react-native";
import { useIsFocused } from "@react-navigation/native";
import i18n from 'i18n-js';
import { backendRequest } from "../../stores/thunks";
import WorkflowCard from "../components/basic/WorkflowCard";
import Filter from "../components/basic/Filter";
import Toast from '../components/basic/Toast';

export default function Home({ navigation }) {
    const isFocused = useIsFocused();

    const user = useSelector((state) => state.user)
    const appTasks = useSelector((state) => state.workflows)
    const studioTasks = useSelector((state) => state.studio)
    const changed = useSelector((state) => state.settings.changed || [])

    const [filteredList, setFilteredList] = useState([])
    const [search, setSearch] = useState('')
    const [filter, setFilter] = useState(0)
    const [toast, setToast] = useState(false)
    const [sort, setSort] = useState(0)
    const dispatch = useDispatch()

    const filters = ['searchScreen.buttonAll', 'searchScreen.buttonMine', 'searchScreen.buttonOthers', 'searchScreen.buttonScanGo', 'searchScreen.buttonStudio', 'searchScreen.buttonApp']
    const sorts = ['searchScreen.alphabetical', 'searchScreen.oldest', 'searchScreen.newest']

    useEffect(() => {
        if (isFocused) {
            dispatch(backendRequest('GET_WORKFLOWS_INLINE', '/contact/user', null, 'GET', false))
        }
    }, [isFocused])

    const searchWorkflows = (element) => {
        return search == '' || (element.title || i18n.t('studio.main.noTitle')).toLowerCase().includes(search.toLowerCase())
    }

    const filterWorkflows = (element) => {
        return !element.deleted && (!filter
            || filter == 0
            || filter == 1 && (element.owned || element.flowData)
            || filter == 2 && (!element.owned && !element.public && element.createdBy?.id !== user.id)
            || filter == 3 && element.public
            || filter == 4 && element.flowData
            || filter == 5 && (element.id?.length < 2 || !element.flowData)
        )
    }

    const sortWorkflows = (a, b) => {
        if (sort == 1) {
            const aDate = a.changed || 0
            const bDate = b.changed || 0

            return aDate - bDate

        } else if (sort == 2) {
            const aDate = a.changed || 0
            const bDate = b.changed || 0

            return bDate - aDate

        } else {    // default alphabetical
            const aTitle = a.title || ''
            const bTitle = b.title || ''

            return aTitle.toLowerCase() > bTitle.toLowerCase() ? 1 : aTitle.toLowerCase() < bTitle.toLowerCase() ? -1 : 0
        }
    }

    useEffect(() => {
        if (studioTasks != undefined) {
            let appWorkflowList = []
            const appWorkflowKeys = Object.keys(appTasks)
            if (appWorkflowKeys?.length > 0) {
                // app workflows without studio id or no longer existing studio workflow
                const studioIdList = studioTasks.map(wf => wf.id)
                appWorkflowList = appWorkflowKeys.filter(id => !appTasks[id].flowData && (!appTasks[id].studio?.id || !studioIdList.includes(appTasks[id].studio.id))).map(id => appTasks[id])
            }
            if (filter == 4) {
                setFilteredList(studioTasks
                    .filter(element => searchWorkflows(element) && filterWorkflows(element))
                    .sort((a, b) => sortWorkflows(a, b))
                )
            } else {
                setFilteredList(studioTasks.concat(appWorkflowList)
                    .filter(element => searchWorkflows(element) && filterWorkflows(element))
                    .sort((a, b) => sortWorkflows(a, b))
                )
            }
        }
    }, [studioTasks, search, filter, sort, appTasks])

    function deleteWorkflowItem(id) {
        dispatch(backendRequest('STUDIO_DELETE_WF', '/studio/workflow/' + id, null, 'DELETE', false))
    }

    function duplicateWorkflow(id) {
        setToast(true)
        setTimeout(() => setToast(false), 5000)
        dispatch(backendRequest('STUDIO_COPY_WF', '/studio/workflow/' + id, null, 'POST', false))
    }

    return (
        <View className="flex-1">
            <VStack className="flex-1 h-[100%] pt-9 px-10 pb-9 items-center overflow-y-scroll overflow-x-clip">
                <VStack space="2xl" className="flex-none max-w-[100%] w-[1100px]">
                    <Text className="text-2xl font-[700] leading-2xl text-secondary-900 ml-2 mb-2">{i18n.t('studio.main.myWorkflows')}</Text>
                    <Filter search={search} setSearch={setSearch} filterTitle={'searchScreen.filterText'} filters={filters} filter={filter} setFilter={setFilter} sortTitle={'searchScreen.sort'} sorts={sorts} sort={sort} setSort={setSort} />
                    <FlatList
                        data={filteredList}
                        renderItem={({ item }) => {
                            return <WorkflowCard item={item} navigation={navigation} deleteItem={deleteWorkflowItem} duplicateItem={duplicateWorkflow} sendItem={true} changed={changed.includes(item.id)} />;
                        }}
                        keyExtractor={(item) => item?.id + '_' + item?.changed}
                        contentContainerStyle={{ flexDirection: 'row', flexWrap: 'wrap' }}
                        ListHeaderComponent={
                            <Pressable hardShadow="3" onPress={() => navigation.navigate('editor')} className="m-2 w-[200px] h-[200px] bg-secondary-50 rounded-md border-primary-900 border-[2px]">
                                <Text aria-label={i18n.t('aria.text.cardadd')} className="text-8xl font-[700] text-primary-900 m-auto">
                                    +
                                </Text>
                            </Pressable>
                        }
                    />
                </VStack>
            </VStack>
            <Toast top="top-[5px]" right="right-[200px]" icon="content-copy" title="studio.editor.copied" toast={toast} setToast={setToast} />
        </View>
    );
}
